import { useCallback, useEffect, useMemo } from 'react'
import { Column, useGlobalFilter, usePagination, useTable } from 'react-table'
import { AxiosRequestConfig } from 'axios'
import useDataTableStore from 'store/dataTable'
import { http } from 'utils'

const useFetch = <T extends object>(
  dataKey: string,
  url?: string,
  cols?: Column<T>[],
  config?: AxiosRequestConfig,
  listName?: string
) => {

  let rowsWithList: T[] | undefined; 
  let data: T[] | undefined; 

  const isLoading = useDataTableStore((state) => state.isLoading)
  // const rows = useDataTableStore(
  //   useCallback((state) => state.data[dataKey] as T[], [dataKey])
  // )
  const rows = useDataTableStore(
    useCallback((state) => state.data[dataKey] as T[], [dataKey])
  )
  
  if (rows && listName && typeof rows === 'object' && listName in rows) {
    console.log("[FETCH DATA]", (rows as Record<string, any>)[listName]);
    rowsWithList = (rows as Record<string, any>)[listName];
  }
  
  const fetch = useDataTableStore((state) => state.fetch)
  const error = useDataTableStore((state) => state.error)
  const setReload = useDataTableStore((state) => state.setReload)

  const columns = useMemo(() => cols || [], [cols])
  data = useMemo(() => {
    if (listName) {
      return rowsWithList || [];
    } else {
      return rows || [];
    }
  }, [rows, rowsWithList, listName]);
  const tableInstance = useTable(
    {
      columns,
      data,
      // initialState: { pageIndex: 0 }
    },
    useGlobalFilter,
    usePagination
    )

  const refresh = useCallback(
    () => fetch(dataKey, url!, config),
    [config, dataKey, fetch, url]
  )

  setReload(refresh)

  useEffect(() => {
    refresh()

    return () => {
      http.cancelAll()
    }
  }, [refresh])

  return { isLoading, error, tableInstance, data, refresh }
}

export default useFetch
